export interface EloTier {
  minRating: number;
  name: string;
  color: string;
  icon: string;
}

export const eloTiers: EloTier[] = [
  { 
    minRating: 0, 
    name: "Madeira", 
    color: "#8B4513",
    icon: "M12 3L4 9V21H20V9L12 3ZM18 19H6V10L12 5.5L18 10V19ZM8 15H16V17H8V15ZM8 11H16V13H8V11Z"
  },
  { 
    minRating: 200, 
    name: "Ferro", 
    color: "#43464B",
    icon: "M12 2L4 7V17L12 22L20 17V7L12 2ZM18 15.5L12 19.2L6 15.5V8.5L12 4.8L18 8.5V15.5Z"
  },
  { 
    minRating: 400, 
    name: "Bronze", 
    color: "#CD7F32",
    icon: "M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM19 11C19 15.52 16.02 19.69 12 20.93C7.98 19.69 5 15.52 5 11V6.3L12 3.19L19 6.3V11Z"
  },
  { 
    minRating: 600, 
    name: "Prata", 
    color: "#C0C0C0",
    icon: "M12 2L4 6V12C4 15.95 7.05 20.45 12 22C16.95 20.45 20 15.95 20 12V6L12 2ZM18 12C18 15.5 15.42 18.68 12 20C8.58 18.68 6 15.5 6 12V7L12 4L18 7V12Z"
  },
  { 
    minRating: 800, 
    name: "Ouro", 
    color: "#FFD700",
    icon: "M12 2L4 7V17L12 22L20 17V7L12 2ZM18 15.5L12 19.2L6 15.5V8.5L12 4.8L18 8.5V15.5ZM12 6L7 9V15L12 18L17 15V9L12 6Z"
  },
  { 
    minRating: 1000, 
    name: "Platina", 
    color: "#00CED1",
    icon: "M12 2L3 7V17L12 22L21 17V7L12 2ZM19 15.6L12 19.5L5 15.6V8.4L12 4.5L19 8.4V15.6Z"
  },
  { 
    minRating: 1200, 
    name: "Esmeralda", 
    color: "#50C878",
    icon: "M12 2L3 7V17L12 22L21 17V7L12 2ZM19 15.6L12 19.5L5 15.6V8.4L12 4.5L19 8.4V15.6ZM12 15L7 12L12 9L17 12L12 15Z"
  },
  { 
    minRating: 1400, 
    name: "Diamante", 
    color: "#B9F2FF",
    icon: "M12 2L3 7V17L12 22L21 17V7L12 2ZM19 15.6L12 19.5L5 15.6V8.4L12 4.5L19 8.4V15.6ZM12 15L7 12L12 9L17 12L12 15Z"
  },
  { 
    minRating: 1600, 
    name: "Mestre", 
    color: "#9370DB",
    icon: "M12 2L3 7V17L12 22L21 17V7L12 2ZM19 15.6L12 19.5L5 15.6V8.4L12 4.5L19 8.4V15.6ZM12 15L7 12L12 9L17 12L12 15ZM12 11.7L14.5 10L12 8.3L9.5 10L12 11.7Z"
  },
  { 
    minRating: 1800, 
    name: "Grão-Mestre", 
    color: "#FF4500",
    icon: "M12 2L3 7V17L12 22L21 17V7L12 2ZM19 15.6L12 19.5L5 15.6V8.4L12 4.5L19 8.4V15.6ZM12 15L7 12L12 9L17 12L12 15ZM12 11.7L15 10L12 8.3L9 10L12 11.7Z"
  },
  { 
    minRating: 2000, 
    name: "Campeão", 
    color: "#FFD700",
    icon: "M12 2L3 7V17L12 22L21 17V7L12 2ZM19 15.6L12 19.5L5 15.6V8.4L12 4.5L19 8.4V15.6ZM12 15L7 12L12 9L17 12L12 15ZM12 11.7L16 10L12 8.3L8 10L12 11.7Z"
  }
];

export const getEloTier = (rating: number): EloTier => {
  // We reverse the tiers to start checking from the highest quality tier first.
  const tier = [...eloTiers].reverse().find(tier => rating >= tier.minRating);
  return tier || eloTiers[0];
};

export const getNextTier = (rating: number): EloTier | null => {
  // Return the first tier whose minRating is greater than the given rating.
  return eloTiers.find(tier => tier.minRating > rating) || null;
};

export const getProgressToNextTier = (rating: number): number => {
  const nextTier = getNextTier(rating);
  if (!nextTier) return 100; // Already at the highest tier, so full progress.

  const currentTier = getEloTier(rating);
  const totalRange = nextTier.minRating - currentTier.minRating;
  const progress = rating - currentTier.minRating;

  return Math.min(100, Math.round((progress / totalRange) * 100));
};